import $ from 'jquery';
import {IMEPluginElement, PluginRunner} from '../../../jsmod/js/registerPlugin';

require('details-element-polyfill');

export class Accordion {
  public static frontend(
    el: HTMLElement,
    opt: {lazy: boolean; group?: string},
  ) {
    return new this($(el), opt);
  }

  public doneInit = false;

  constructor(
    public $elem: JQuery,
    public opt: {lazy: boolean; group?: string},
    public updateHook?,
  ) {
    this.initDescendants();
  }

  public initDescendants() {
    if (this.$elem) {
      let $el = this.$elem.children('details');
      if (this.$elem.children('.me-iwrap').length) {
        $el = this.$elem.children('.me-iwrap').children('details');
      }

      $el.on('toggle', (e) => {
        this.toggle(e);
      });

      $el.on('click', (e) => {
        if (this.opt.hasOwnProperty('group')) {
          $(`[data-group="${this.opt.group}"]`)
            .not($(e.target).parents('details'))
            .removeAttr('open');
        }
      });
    }
  }

  public toggle(e) {
    if ($(e.target).attr('open') === 'open' && !this.doneInit) {
      if (this.opt.lazy) {
        const myId = this.$elem.attr('id');
        const lazyIds = this.$elem
          .parents('.me-lazy')
          .get()
          .map((el) => el.id);
        lazyIds.push(myId);
        this.$elem
          .children('.me-iwrap')
          .children('details')
          .attr('loading', true as any);
        $.ajax(window.location.href, {
          method: 'GET',
          data: {lazy: lazyIds},
        }).then((data) => {
          const $old = this.$elem
            .children('.me-iwrap')
            .children('details')
            .children('article');
          const $src = $(data).find(`#${myId} > .me-iwrap > details > article`);
          console.log($old, $src);
          const runner = PluginRunner.getInstance();
          runner.replaceEl($old.get(0), $src.get(0));
          this.$elem
            .children('.me-iwrap')
            .children('details')
            .removeAttr('loading');
          this.initVisibleChildren();
        });
      } else {
        this.initVisibleChildren();
      }
      this.doneInit = true;
    }
  }

  public initVisibleChildren() {
    this.$elem.find(`[data-parent=${this.$elem.attr('id')}]`).each((i, el) => {
      PluginRunner.getInstance().initElement(el as IMEPluginElement);
      const children = $(el).children().get();
      if (children.length > 0 && children[0].tagName === 'IFRAME') {
        $(el).children().trigger('load');
      }
    });
  }
}
